import React from "react";
import "./layout.scss";
import "../../css/style.scss";
import Footer from "../footer/footer";
import Header from "../header/header";

const Layout = ({ isHomePage, children }) => {
  return (
    <>
      <div
        className="global-wrapper"
        data-is-root-path={isHomePage}
      >
        <div className="container-width">
          <Header />
          <main>{children}</main>
        </div>
      </div>
      <Footer
        showAboutCompany={false}
        showDisclaimer={false}
      />
    </>
  );
};

export default Layout;
